import { render } from "./moreIncome.vue?vue&type=template&id=f50e198e&scoped=true"
import script from "./moreIncome.vue?vue&type=script&lang=js"
export * from "./moreIncome.vue?vue&type=script&lang=js"

import "./moreIncome.vue?vue&type=style&index=0&id=f50e198e&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50e198e"]])

export default __exports__